<template>
  <div >

    <v-dialog v-model="dialog_video" max-width="660px" persistent>


      <v-card >
        <v-card-title>
          Doctor On Crutches Interview
          <v-spacer></v-spacer>
          <v-btn icon @click="close_video_dialog"><v-icon>close</v-icon></v-btn>
        </v-card-title>
        <div class="video-dialog">
          <player ytid="vF7yen0nRjM" ref="youtube" :playerVars="yt_vars"></player>

          <!--<vue-youtube video-id="vF7yen0nRjM" ref="youtube"></vue-youtube>-->
        </div>



      </v-card>



    </v-dialog>


    <!--<div style="position: relative; z-index: -1" width="100%">-->
      <!--<v-img src="../assets/images/content/math.png"  ></v-img>-->
    <!--</div>-->

    <Section background="white"  class="image-bg"
             :style="{'background-image': `url(${require('../assets/images/content/iStock-870849902-25percent.png')})`}"
    >

      <nav-bar></nav-bar>
      <div class=" main-heading heading-line">


        <v-container>
          <v-row justify="center">
            <v-col cols="12" sm="10" justify="center">
              <div class="center display-2">Better Living Endoscopy Center</div>
              <div class="center title">Gastroenterology and Internal Medicine</div>

              <v-btn x-large href="tel:6016389800" color="accent"
                     class="text--primary mt-9"
                     @click.native="track('HomeCallBtn', 'ClickToCall')" >Call 601-638-9800<br>For an Appointment</v-btn>
              <!--<v-btn x-large to="/contact" color="accent" class="text&#45;&#45;primary mt-9" >Request Appointment</v-btn>-->

            </v-col>
            <v-col grow></v-col>
          </v-row>
        </v-container>

      </div>
    </Section>



    <!-------------------------------------------Services------------------------------------------------------------>

    <Section background="white">
      <div class="section"  >

        <div class="heading">
          Our Services

          <!--<hr style="max-width:400px; margin: auto; border-width: 10px; ">-->
          <!--<v-divider style="max-width: 500px; margin: auto; border-width: 1px;"></v-divider>-->
          <div class="mydivider" style="max-width: 200px;"
          ></div>
        </div>

        <v-container class="container-services">

          <v-row class="pb-10">
            <v-col cols="12" sm="4" >

              <img src="../assets/images/icons/doctor.png" height="100px">

              <div class="section-sub-heading">Practice</div>
              <div class="service-text">
                Our clinic provides evaluations for all ailments of the Digestive tract including Colon cancer,
                GERD, Peptic Ulcers, IBS, IBD and Ulcerative Colitis. Please see our Services page for more information.
              </div>
            </v-col>
            <v-col cols="12" sm="4">
              <img src="../assets/images/icons/operating.png" height="100px">
              <div class="section-sub-heading">Procedures</div>
              <div class="service-text">
                We perform a  variety of procedures related to the digestive track including Colonoscopies, EGD's,
                Esophageal Dilations, and hemorrhoid treatments.

              </div>

            </v-col>
            <v-col cols="12" sm="4">
              <img src="../assets/images/icons/pharmacy.png" height="100px">
              <div class="section-sub-heading">Surgical Center</div>
              <div class="service-text">
                Our Endoscopy Center is an AAAHC accredited surgical center, and provides our patients with a
                convenient and cost effective environment for having their Colonoscopy, Endoscopy, and other procedures
                performed.


                <!--designed with patient satisfaction as . Our facility focuses on the highest level of quality, safety, privacy, and convenience for our patients. Having a procedure performed at Better Living Endoscopy allows the patient to return home quickly and comfortably.-->

                <!--<a href="https://www.ncbi.nlm.nih.gov/pubmed/17098615">ref</a>-->

              </div>

            </v-col>
          </v-row>


          <v-row class="pt-5 pb-10">
            <v-spacer></v-spacer>
            <v-btn x-large to="/services"
                   color="accent"
                   class="text--primary"
                   @click.native="track('HomeLearnMore')"
            >
              Learn More
            </v-btn>
            <v-spacer></v-spacer>
          </v-row>

        </v-container>
      </div>

    </Section>


<!--     <div style="background-color: rgba(95,149,157,0.27)">-->
<!--        <div style="text-align: center; font-size: 30pt;">-->
<!--           Special Announcement-->
<!--        </div>-->
<!--        -->
<!--        <div style="display: flex; justify-content: center">-->
<!--           <div style="display: flex; justify-content: space-between; max-width: 1800px">-->
<!--       -->
<!--              <img src="/temp/REST_VICKSBURG_BROCHURE_1.jpg" style="width: 30%" @click="navigate('/temp/REST_VICKSBURG_BROCHURE_1.jpg')"/>-->
<!--              <img src="/temp/REST_VICKSBURG_BROCHURE_2.jpg" style="width: 30%" @click="navigate('/temp/REST_VICKSBURG_BROCHURE_2.jpg')"/>-->
<!--              <img src="/temp/REST_VICKSBURG_BROCHURE_3.jpg" style="width: 30%" @click="navigate('/temp/REST_VICKSBURG_BROCHURE_3.jpg')"/>-->
<!--           </div>-->
<!--        </div>-->
<!--        -->
<!--        -->
<!--     </div>-->

     


     

    <!-------------------------------------------About--------------------------------------------------------------->




    <Section background="white">
      <div class="section"  style="background-color: #f1f1f1;">

        <div class="heading">
          About Yoshinobu Namihira, MD, FACG

          <!--<hr style="max-width:400px; margin: auto; border-width: 10px; ">-->
            <!--<v-divider style="max-width: 500px; margin: auto; border-width: 1px;"></v-divider>-->
          <div class="mydivider" style="max-width: 470px;"
          ></div>


        </div>

        <v-container>
          <v-row>
            <v-col cols="12" sm="4" align="center" class="content-image" >
              <img src="../assets/images/content/namihira.png" >
            </v-col>

            <v-col cols="12" sm="8" class="content-text">
              <p>
                Dr. Namihira is a gastroenterologist with over 30 years of experience serving the Vicksburg community.
                He graduated Loma Linda Medical School in 1981, completed his Residency in Internal Medicine,
                and then completed a Fellowship in Gastroenterology.
              </p>

              <p>
                Dr. Namihira is Board certified and is a Fellow of the American College of Gastroenterology (FACG).
                In addition, he is affiliated with the following organizations:
              </p>
              <ul style="text-align: left">
                <li>American Board of Internal Medicine</li>
                <li>American College of Gastroenterology</li>
                <li>American Association for Gastrointestinal Endoscopy</li>
                <li>American Gastroenterological Association</li>
                <li>American College of Gastroenterology</li>
                <li>American Society of Gastrointestinal Endoscopy</li>
              </ul>


            </v-col>
          </v-row>
          <v-row class="pt-5 pb-10">
            <v-spacer></v-spacer>



             <div
                 style="cursor: pointer"
                 @click="dialog_video=true"
                 @click.native="track('SeeVideoInterview')"
             >
                <img class="image" src="../assets/images/content/namihira_patient_play.png">
                <div style="font-weight: 500; text-align: center">
                   Dr.Namihira's Life Story
                </div>
             </div>
            <!--<v-btn large-->
            <!--       color="#81d4fa"-->
            <!--       @click="dialog_video=true"-->
            <!--       @click.native="track('SeeVideoInterview')"-->
            <!--&gt;-->
            <!--  Learn More About Dr. Namihira-->
            <!--</v-btn>-->
            <v-spacer></v-spacer>
          </v-row>
        </v-container>
      </div>

    </Section>





    <!-------------------------------location info----------------------------------------------------------------->
    <Section background="white">
      <div class="section">

        <div class="heading">
          Office Location
          <div class="mydivider" style="max-width: 230px;"></div>
        </div>

        <location></location>
      </div>
    </Section>



  </div>

</template>






<style scoped lang="scss">



  .image-bg{
       background-size: cover;
       background-position: center;
     }


  .main-heading{
    height: 500px;
    display: flex;
    align-items: center;
    justify-content: center;
    /*background-image: url('../assets/images/content/math.png')*/

    /*background-size: cover;*/
    /*!*background-size: auto 100%;*!*/
    /*!*background-size: 100% auto;*!*/
    /*background-position: center;*/
    }

  .process-section{
    height: 700px;
    text-align: justify;

  }
  .heading-line{
    text-align: center;

  }


  .bg-transparent-light{
    background: rgba(255, 255, 255, 0.05);
    width:100%;
    padding-top: 50px;
    padding-bottom: 50px;

  }


  .section-heading{
    font-size: 3em;
    padding-top: 10px;
    padding-bottom: 10px;
    width: 100%;
    text-align: center;

  }


  .section-sub-heading {
    font-size: 2em;
    font-weight: normal;
  }



  .container-services{
    max-width: 1200px;
    text-align: center;


    /*.service-heading{*/
      /*font-size: 2em;*/
      /*font-weight: normal;*/
    /*}*/



    .service-text{
      font-size: 1.0em;
      /*font-weight: lighter;*/
      line-height: 110%;
      text-align: justify;
      padding-top: 10px;
      padding-left: 5px;
      padding-right: 5px;
    }
  }

  .colored-icon-text{
    font-size: 1.4em;
    /*font-size: 1.0em;*/
    /*text-align: left;*/
    text-align: justify;
    max-width: 800px;
  }



  .mydivider{
    height: 1.5px;
    background: #aaaaaa;
    margin: auto;

    /*width: 400px;*/
    box-shadow: 2px 2px 4px #afafaf;

  }



  .section{
    width: 100%;
    min-height: 500px;
    /*background-color: #f1f1f1;*/
    padding-top: 50px;
    padding-bottom: 50px;

    .heading {
      text-align: center;
      font-size: 2.4em;
      padding-bottom: 30px;
    }



    .content-image{
      img{
        width: 100%;
        box-shadow: 2px 2px 8px #a8a8a8;
        max-width:300px;
      }
    }

    .content-text{
      max-width: 700px;
      text-align: justify;
      font-size: 1.3em;
    }
  }







  /*.location{*/

    /*.heading-location{*/
      /*font-size: 1.2em;*/
      /*font-weight: bold;*/
      /*color: gray;*/

    /*}*/
    /*.text-location{*/
      /*font-size: 1em;*/
      /*padding-left: 10px;*/
    /*}*/

  /*}*/























  .slide-container{
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    min-height: 200px;
  }

  .slide-content{
    margin: auto;
    padding-left: 20px;
    padding-right: 20px;
    max-width: 700px;

  }
  .slide-spacer{
    flex: 'flex-grow';
  }



  .video-dialog{
    width: 660px;
    /*height: 480px;*/
    padding: 10px;


  }




</style>


<script>
// @ is an alias to /src
import Section from '@/components/Section.vue'
import Contact from '@/components/ContactForm.vue'
import navBar from '@/components/navBar.vue'
import location from '@/components/location.vue'


// import VueYoutube from 'vue-youtube'
import VuePlayerPlugin, { Player } from 'vue-youtube-iframe-api';

import Vue from 'vue'


Vue.use(VuePlayerPlugin);

export default {
  name: 'home',
  components: {navBar, Section, location, Player},
   data(){return {
      dialog_video: false,
      yt_vars: {},

   }},


   methods:{
      track (eventLabel, category='SiteNavigation') {
         console.log(eventLabel);
         this.$gtag.event('ButtonClick', {
            'event_category': category,
            'event_label': eventLabel,
         })
      },

      close_video_dialog(){
         this.dialog_video = false;
         this.stopPlayingVideo();
      },


      stopPlayingVideo(){
         this.$refs.youtube.player.stopVideo();
      },
      
      navigate(path){
         window.location=path;
      }
      
      
   },

   computed:{
     slide_ratio(){

        if (['xs'].includes(this.$vuetify.breakpoint.name)){
           return 0.7;
        }

        else if (['sm'].includes(this.$vuetify.breakpoint.name)){
           return 0.5;
        }
        else {
           return 0.3;
        }
     }
   }


}
</script>
